(function () {
  'use strict';
  var IST = 5.5 * 3600 * 1000;
  function pad(n) { return String(n).padStart(2, '0'); }
  function secsLeft(el) {
    if (el.getAttribute('data-mode') === 'daily') {
      var now = Date.now(), d = new Date(now + IST);
      var next = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 1) - IST;
      return Math.max(0, Math.floor((next - now) / 1000));
    }
    var end = new Date(el.getAttribute('data-end')).getTime();
    if (isNaN(end)) return null;
    return Math.max(0, Math.floor((end - Date.now()) / 1000));
  }
  function tick() {
    [].slice.call(document.querySelectorAll('[data-announce-timer]')).forEach(function (el) {
      var s = secsLeft(el), wrap = el.closest('.announce__timer');
      if (s === null) { if (wrap) wrap.style.display = 'none'; return; }
      if (s === 0 && el.getAttribute('data-mode') !== 'daily') {
        var bar = el.closest('[data-announce]'); if (bar) bar.style.display = 'none'; return;
      }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    });
  }
  if (document.querySelector('[data-announce-timer]')) { tick(); setInterval(tick, 1000); }
  var offers = [].slice.call(document.querySelectorAll('[data-announce-offers] .announce__offer'));
  if (offers.length > 1) {
    var i = 0;
    setInterval(function () {
      offers[i].classList.remove('is-on'); i = (i + 1) % offers.length; offers[i].classList.add('is-on');
    }, 2800);
  }
})();
